/* global locale, cartInvalid, isPudoInfoAvailable, paymentMethod, pspClientInfo, SendAdobeData, stickyButtonOnPreviewPageVariations, isMobileAppPayPalSdkIntegrationEnabled */ // for ESLint
import events from 'events-bus';
import misc from '../components/misc';
import modal from '../components/modal';
import { logError, logException } from '../services/sentryService';
import {
  getUiLibraryClasses,
  showPageLoader,
  showUntilLimit,
  dsMapToDeliveryServiceDto,
  dsMapToPudoInfo,
  hidePageLoader,
  sendAdobeData,
  focusAccessibleAlert,
  applyClassBasedOnResolution,
  geDeliveryObjectJson,
  collectBrowserInformation,
  getDeviceType,
} from '../utils';
import infoBox from '../components/infoBox';
import CONSTANTS from '../lib/constants';
import cookies from '../utils/cookies';
import { initCouponModal } from '../components/coupon';
import SepaExpressService from '../services/sepaExService';
import { ApplePayUtils } from '../utils/applepay-utils';
import { initCustomPaypalButton } from '../utils/mobile-app-paypal-integration';

const PREVIEW = {};
const isDeliveryServicePudo = $('.js-deliveryServicePudo');
const $placeOrderBtn = $('.js-placeOrderBtn');
const $placeOrderSummary = $('.placeOrderSummary');
const $placeOrderForm = $('#js-placeOrderForm');
const $priceInfo = $('.price__info');
const $previewPageTop = $('.preview__box-top');
const $legalText = $('#js-legal_text');
const $reducedPriceTooltip = $('.reducedPriceTooltip');
const $bestPriceTooltip = $('.bestPriceTooltip');
const stickyButtonVariations =
  typeof stickyButtonOnPreviewPageVariations !== 'undefined'
    ? JSON.parse(stickyButtonOnPreviewPageVariations)
    : {};
const makeTheOrderBtn = document.getElementById('makeTheOrder');
const adyenApplePayBtn = document.getElementById('adyen-apple-pay-button');
const RIVERTY_INVOICE = 'RI';

let deliveryServiceAvailable = true;

const renderInvalidPhoneNumberWarning = () => {
  if (window.isPhoneNumberValid === false && window.alertMessage) {
    window.alertMessage.render({
      elementId: 'phone-number-warning-message',
      type: 'caution',
      invalidPhoneNumber: true,
    });
  }
};

function attachOnSubmitEvent() {
  $placeOrderForm.on('submit', function () {
    //Heureka opt in checkbox
    const heurekaOptIn = $('#heurekaOptIn');
    $('#js-heurekaOptIn').val(heurekaOptIn && heurekaOptIn.is(':checked'));

    //Subscribe to newsletter opt in checkbox
    const subscribeToNewsletterOptIn = $('#subscribeToNewsletterCheckbox');
    $('#js-subscribeToNewsletter').val(
      subscribeToNewsletterOptIn && subscribeToNewsletterOptIn.is(':checked')
    );

    // SC-5138: show modal to app users who are completing their purchase in the mobile browser
    const isMobileApp = cookies.get('MOBILE_APP');
    if (isMobileApp) {
      const showPaymentIncompletePopup = () => {
        if (document.hidden) {
          const timeoutId = setTimeout(() => {
            const paymentIncompleteModal$ = $('.js-payment-incomplete-modal');
            if (paymentIncompleteModal$.length > 0) {
              modal.openModal(paymentIncompleteModal$);
            }
            clearTimeout(timeoutId);
            document.removeEventListener(
              'visibilitychange',
              showPaymentIncompletePopup
            );
          }, 3000);
        }
      };

      document.addEventListener('visibilitychange', showPaymentIncompletePopup);
    }
  });
}

function subscriptionBox() {
  let $subscriptionProductContainer = $('.js-product__container');
  let $productCount = $('.js-product__count');
  let $products = $('.js-product__box');

  $('input[type=radio][name=subscription_select]').change(function () {
    let selectedValue = $(this).val();
    if (selectedValue === 'yes') {
      $('.choice__yes').addClass('active');
      $('.choice__no').removeClass('active');
    } else {
      $('.choice__yes').removeClass('active');
      $('.choice__no').addClass('active');
    }
  });

  if ($subscriptionProductContainer.length > 0) {
    let itemsAmount = Math.floor(
      $subscriptionProductContainer.width() / $products.outerWidth(true)
    ); // Amount of items that fit on the screen
    let totalItems = parseInt($productCount[0].className.split(' ')[1]); // Total amount of items in the subscription
    let restItems =
      itemsAmount > 0 ? totalItems - (itemsAmount - 1) : totalItems; // Amount of items that do not fit on the screen
    showUntilLimit(itemsAmount, $products);
    if (restItems > 0) {
      $productCount.html(restItems);
      $('.product__box.extra__products').removeClass('hidden');
    } else {
      if (totalItems - 4 === 0 || restItems <= 0) {
        $('.product__box.extra__products').addClass('hidden');
      } else {
        $productCount.html(totalItems - 4);
        $('.product__box.extra__products').removeClass('hidden');
      }
    }
  }
}

function subscriptionDetailView() {
  let $mainProductContainer = $('.js-product__container');
  let $openSubscriptionLink = $('.js-open-subscription');

  if ($mainProductContainer.length === 0) {
    return;
  }

  $openSubscriptionLink.click(function (e) {
    e.preventDefault();
    let $modal = $('.js-subscription-modal');

    if ($modal.length > 0) {
      modal.openModal($modal);
    }
  });
}

function subscriptionMoreInfoView() {
  let $moreInformationLink = $('.js-subscription-content-open');

  if ($moreInformationLink.length === 0) {
    return;
  }

  $moreInformationLink.click(function () {
    let $modal = $('.js-subscription-content-modal');

    if ($modal.length > 0) {
      modal.openModal($modal);
    }
  });
}

const deliveryOptionSelector = (elem, option, optionClass) => {
  if (elem) {
    option.removeClass('selected');
    $(`.${optionClass} > input[type=radio]`).prop('checked', false);
    if (elem.hasClass(optionClass)) {
      elem.addClass('selected');
      elem.find('input[type=radio]').prop('checked', true).change();
    } else if (elem.is('label')) {
      elem
        .parent(`.${optionClass}`)
        .find('input[type=radio]')
        .prop('checked', true)
        .change();
      elem.parent(`.${optionClass}`).addClass('selected');
    }
  }
};

const disablePaypalButton = () => {
  if (
    window.isFeaturePaymentFrontendPaypalButtonEnabled &&
    window.Payment?.disablePayPalButton
  ) {
    window.Payment.disablePayPalButton();
  } else {
    const paypalButtonContainer = document.getElementById(
      'js-paypal-button-container'
    );

    if (!paypalButtonContainer) return;

    paypalButtonContainer.classList.add('paypal__btn--disabled');
  }
};

const enablePaypalButton = () => {
  if (
    window.isFeaturePaymentFrontendPaypalButtonEnabled &&
    window.Payment?.enablePayPalButton
  ) {
    window.Payment.enablePayPalButton();
  } else {
    const paypalButtonContainer = document.getElementById(
      'js-paypal-button-container'
    );

    if (!paypalButtonContainer) return;

    paypalButtonContainer.classList.remove('paypal__btn--disabled');
  }
};

const disableOrderButton = () => {
  const placeOrderButton = document.querySelector('.js-placeOrderBtn');
  const cartButtonClass = `${CONSTANTS.UI_LIBRARY_PREFIX}-btn--cart`;
  const loadingClass = getUiLibraryClasses(['btn--loading']);

  if (!placeOrderButton) return;

  if (placeOrderButton.classList.contains(loadingClass)) {
    placeOrderButton.classList.remove(loadingClass);
  }
  placeOrderButton.classList.remove(cartButtonClass);
  placeOrderButton.disabled = true;
  placeOrderButton.setAttribute('aria-disabled', 'true');
};

const initDeliveryOptionsComponent = () => {
  const deliveryData = geDeliveryObjectJson();
  const deliveryServicesElement = document.querySelector('delivery-services');

  if (!deliveryServicesElement) return;

  // Events
  events.on(CONSTANTS.DELIVERY_SERVICE_SELECTED, (eventName, payload) => {
    const deliveryService = payload.deliveryService;
    const deliveryServiceId = deliveryService.deliveryServiceId;
    const dspForm = $('[name="changeDSP"]');
    const currentDeliveryServiceId = dspForm
      .find('.js-selectedDeliveryServiceId')
      .val();

    isDeliveryServicePudo.val(deliveryService.pickUpDropOff ? 'true' : 'false');

    if (!deliveryServiceId) {
      logError(`Delivery service is not assigned: ${payload}`);
    }
    // Assign the new ID
    $('.js-selectedDeliveryServiceId').attr('value', deliveryServiceId);

    // Assign the DS Restrictions
    $('.js-selectedDeliveryServiceRestrictions').attr(
      'value',
      JSON.stringify(deliveryService.restrictions)
    );

    if (deliveryService.pickUpDropOff) {
      const isPudoInfoParseable =
        payload.pudo && payload.pudo?.collector && payload.pudo?.pudoPoint;

      const pudoInfoAsString = isPudoInfoParseable
        ? JSON.stringify(
            dsMapToDeliveryServiceDto(
              payload.pudo,
              deliveryData?.customer?.email
            )
          )
        : null;
      const isPudoInfoChanged =
        document.getElementById('pudoInfoObject').innerText !==
        pudoInfoAsString;

      if (isPudoInfoChanged) {
        const pudoForm = $('[name="dsChangePUDO"]');
        $('.js-ds-selectedDeliveryServiceId').attr('value', deliveryServiceId);
        $('.js-ds-pudoInfoObj').attr('value', pudoInfoAsString);
        pudoForm.submit();
      }

      if (typeof isPudoInfoAvailable !== 'undefined' && isPudoInfoAvailable) {
        $('.js-normalDeliveryAddress').addClass('hidden');
        $('.js-pudoDeliveryAddress').removeClass('hidden');
      }
    } else {
      // First time on the page
      if (!currentDeliveryServiceId) {
        $('.js-defaultDeliveryServiceId').attr('value', deliveryServiceId);
        return;
      }

      // Avoid page reload (loose equality operator is intended)
      if (currentDeliveryServiceId == deliveryServiceId) return;

      // Submit the form, so the deliveryServiceId value is populated
      dspForm.submit();
    }
  });

  events.on(CONSTANTS.DELIVERY_SERVICE_UNAVAILABLE, (eventName, payload) => {
    const errorMessage = payload.message;
    const infoBoxPreview = infoBox({ selector: '.js-infoBoxPreview' });
    deliveryServiceAvailable = false;
    disableOrderButton();
    disablePaypalButton();
    infoBoxPreview.show({ message: errorMessage, type: 'ERROR' });
  });

  events.on(CONSTANTS.DELIVERY_SERVICE_INFO, (eventName, payload) => {
    $.ajax({
      type: 'post',
      url: '/checkout/preview/delivery-service-info',
      data: JSON.stringify(payload),
      contentType: 'application/json; charset=utf-8',
    });
  });

  initPudoDialog(deliveryServicesElement);

  deliveryServicesElement.setAttribute(
    'cartdata',
    JSON.stringify(deliveryData)
  );
};

const initPudoDialog = (deliveryServicesElement) => {
  const pudoInfoObjectAsString =
    document.getElementById('pudoInfoObject').innerText;
  pudoInfoObjectAsString &&
    deliveryServicesElement.setAttribute(
      'pudoinfo',
      JSON.stringify(dsMapToPudoInfo(JSON.parse(pudoInfoObjectAsString)))
    );
};

const isDesktopView = () => window.innerWidth >= 1024;
const isMobileView = () => window.innerWidth < 768;

function initPaypalButton() {
  if (isMobileAppPayPalSdkIntegrationEnabled) {
    return initCustomPaypalButton();
  }

  if (window.isFeaturePaymentFrontendPaypalButtonEnabled || !window.paypal) {
    window.Payment.PayPal.renderCheckoutButton({
      onApprove: function (payPalOrderId) {
        $('#js-paypalOrderId').val(payPalOrderId);
        showPageLoader();
        $placeOrderForm.submit();
      },
      onCancel: () => {},
    });
    return;
  }

  let cartEl = document.getElementById('cartDataObject').innerText;
  let cartDataObject = null;
  try {
    cartDataObject = cartEl !== '' ? JSON.parse(cartEl) : null;
  } catch (e) {
    logException(e, { area: 'payment', payment: 'paypal' });
  }

  let isPlaceOrderFormSubmitted = false;
  if (cartDataObject) {
    const customer = cartDataObject.customer;
    let button = window.paypal.Buttons({
      fundingSource: window.paypal.FUNDING.PAYPAL,
      // Validation check for AGB
      onInit: function (data, actions) {
        // Disable the buttons
        actions.disable();
        if (deliveryServiceAvailable) {
          actions.enable();
        }
      },
      style: {
        color: 'gold',
        shape: 'pill',
        layout: 'vertical',
        label: window.location.href.includes('zoohit.si') ? 'paypal' : 'buynow',
      },
      onClick: function () {
        if (typeof SendAdobeData === 'function') {
          SendAdobeData(
            'customClickTrack',
            'Checkout',
            'Paypal Preview Button',
            'Buy Now'
          );
        }
      },
      createOrder: async () => {
        setTimeout(() => {
          const paypalSandbox = $('div.paypal-checkout-sandbox');
          paypalSandbox.length === 1
            ? sendAdobeData('PaypalModalDisplayed')
            : sendAdobeData('PaypalModalNotDisplayed');
        }, 2000);
        disablePaypalButton();
        try {
          const paypalOrderAmount = $('#js-paypalOrderAmount').val();
          const response = await fetch(
            '/checkout/paypal-order?previewPageAmount=' + paypalOrderAmount,
            { method: 'GET' }
          );
          if ((await response.status) == 409) {
            //'conflict' means the page is stale -- cart has been modified
            //refresh + print cart changed
            location.href = '/checkout/preview?paypalConsistencyCheck=true';
            showPageLoader();
            return false;
          } else {
            const jsonResponse = await response.json();
            return jsonResponse.paypalOrderId;
          }
        } catch (error) {
          console.error(error);
          // Handle the error or display an appropriate error message to the user
          $('#js-paypalErrorMessage').removeClass('hide');
          enablePaypalButton();
        }
      },
      onApprove: function (data) {
        showPageLoader();
        // Assign paypal order id
        $('#js-paypalOrderId').val(data.orderID);

        // Try to prevent placing of another order if `onApprove` handler is called by Paypal SDK more than once for some reason
        if (!isPlaceOrderFormSubmitted) {
          isPlaceOrderFormSubmitted = true;
          $placeOrderForm.submit();
        } else {
          logError(
            `Paypal order placed more than once for customer ${customer.customerId}`
          );
        }
      },
      onCancel: function () {
        // Enable the PayPal button again
        enablePaypalButton();
      },
      onError: function () {
        // Show an error page here, when an error occurs
        $('#js-paypalErrorMessage').removeClass('hide');
        enablePaypalButton();
      },
    });

    if (button.isEligible()) {
      button.render('#js-paypal-button-container');
    }
  }
}
function renderApplePayButton(localPaymentMethods) {
  window.Payment.renderAdyenApplePayButton(
    JSON.parse(localPaymentMethods),
    (data) => {
      $('#js-applePayOrderId').val(data);
      showPageLoader();
      $placeOrderForm.submit();
    },
    (error) => {
      if (error !== 'CANCEL') {
        window.location.replace(
          window.location.origin + '/checkout/editpayment?browserSupport=failed'
        );
      }
    }
  );
}
function initBraintreeVerification() {
  if (
    document.getElementsByClassName('js-braintreeDeviceData')[0].value === ''
  ) {
    showPageLoader();
    window.Payment?.braintreeAuthorize()
      .then((result) => {
        document.getElementsByClassName('js-braintreeDeviceData')[0].value =
          result.deviceData;
        document.getElementsByClassName('js-braintreeVerifiedNonce')[0].value =
          result.nonce;
        $placeOrderForm.submit();
      })
      .catch((error) => {
        if (!error.retryable) {
          location.href = '/checkout/editpayment?creditCardCheckStatus=failed';
        } else {
          hidePageLoader();
        }
        logError(
          `Preview order placement 3D Secure check failed: ${error.message}`
        );
      });
  }
}

function loadRivertyProfileTrackingScript() {
  if (
    !window.rivertyProfileTrackingShopId ||
    !window.sid ||
    !window.shopRootDomain
  ) {
    return;
  }

  const config = {
    c: window.rivertyProfileTrackingShopId,
    s: window.sid,
    u: window.location.pathname,
    h: `rvt.${window.shopRootDomain}`,
  };
  window._itt = config;
  const scriptSource = `https://${config.h}/container/${config.c}?page=${config.u}`;
  addScriptToDocument(scriptSource);
}

function addScriptToDocument(src) {
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.onload = function () {
    this.remove();
  };
  (document.head || document.documentElement).appendChild(script);
}

function isVisible(el) {
  let rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function toggleBuyButtonByVariations() {
  const placeOrderButton = document.getElementById('placeOrderSummary');
  if (
    isMobileView() &&
    window.isStickyButtonOnPreviewPageEnabled &&
    stickyButtonVariations.variant
  ) {
    placeOrderButton.style.position = 'inherit';
    placeOrderButton.style.boxShadow = 'inherit';
    placeOrderButton.style.padding = '0';
    $priceInfo[0].append($placeOrderForm[0]);
  }
}

const getBrowserInformation = () => {
  if (typeof paymentMethod === 'undefined') {
    logError('Skipping browser info collection: paymentMethod is undefined');
    return;
  }

  const METHODS_REQUIRING_BROWSER_INFO = ['AK', 'BC'];
  if (!METHODS_REQUIRING_BROWSER_INFO.includes(paymentMethod)) {
    return;
  }

  try {
    const browserInfo = collectBrowserInformation();
    const $browserInfoInput = $('#js-browserInfo');

    if (!$browserInfoInput.length) {
      logError('Input element #js-browserInfo not found');
      return;
    }

    $browserInfoInput.val(JSON.stringify(browserInfo));
  } catch (error) {
    logError('Error serializing browser info:', error);
  }
};

const publishDeliveryMetrics = async () => {
  try {
    const deliveryData = geDeliveryObjectJson();
    if (!deliveryData) return;

    const { cart = {}, customer = {} } = deliveryData;
    const { cartId, siteId, currency, locale, domain } = cart;

    const isMetricsAgentAvailable =
      window.DeliveryServicesMetricsUIAgent?.publishMetrics;

    const isMetricsEligibleForSending = Boolean(
      cartId && siteId && currency && domain && locale
    );

    if (!isMetricsEligibleForSending && !isMetricsAgentAvailable) {
      return;
    }

    const isGuestCustomer = customer?.type === 'GC';

    const metricsData = {
      sid: window.sid || '',
      cartId: cartId?.toString() || '',
      site: {
        id: siteId,
        domain: domain || '',
        locale: locale || '',
        currencyCode: currency || '',
      },
      page: {
        name: isGuestCustomer ? 'CHECKOUT_PREVIEW_GUEST' : 'CHECKOUT_PREVIEW',
        pageLocation: window.location.href,
      },
      customer: {
        id: customer.customerId?.toString() || '',
        isGuest: isGuestCustomer,
      },
    };

    await window.DeliveryServicesMetricsUIAgent.publishMetrics(
      metricsData.sid,
      metricsData.cartId,
      metricsData.site,
      metricsData.page,
      getDeviceType(),
      metricsData.customer
    );
  } catch (error) {
    logError('Failed to publish delivery services metrics:', error);
  }
};

PREVIEW.init = function () {
  getBrowserInformation();
  window.paymentMethod === 'AP' &&
    !ApplePayUtils.isEnabled() &&
    window.location.replace(
      window.location.origin + '/checkout/editpayment?browserSupport=failed'
    );
  subscriptionBox();
  subscriptionDetailView();
  subscriptionMoreInfoView();
  $(window).resize(
    misc.debounce(function () {
      subscriptionBox();
    }, 50)
  );
  const isMobileApp = cookies.get('MOBILE_APP');

  !isMobileApp && toggleBuyButtonByVariations();

  // Check if it's the native mobile app
  if (typeof isMobileApp !== 'undefined' && isMobileApp !== null) {
    $priceInfo[0].append($placeOrderForm[0]);
  }
  window.addEventListener('scroll', function () {
    if (isDesktopView()) {
      let isPlaceOrderSummaryVisible = isVisible($placeOrderSummary[0]);
      switch (true) {
        case $priceInfo.position().top === 0 &&
          typeof $priceInfo[0].lastChild.getAttribute === 'function' &&
          $priceInfo[0].lastChild.getAttribute('id') === 'js-placeOrderForm':
          $priceInfo[0].prepend($placeOrderForm[0]);
          break;
        case isVisible($previewPageTop[0]) && !isPlaceOrderSummaryVisible:
          $priceInfo[0].prepend($placeOrderForm[0]);
          break;
        case !isPlaceOrderSummaryVisible &&
          typeof $priceInfo[0].childNodes[1].getAttribute === 'function' &&
          $priceInfo[0].childNodes[1].getAttribute('id') ===
            'js-placeOrderForm':
          $priceInfo[0].append($placeOrderForm[0]);
          break;
        case !isPlaceOrderSummaryVisible &&
          typeof $priceInfo[0].firstChild.getAttribute === 'function' &&
          $priceInfo[0].firstChild.getAttribute('id') === 'js-placeOrderForm':
          $priceInfo[0].append($placeOrderForm[0]);
          break;
      }
    }
  });

  $('.js-show-sepa-popup a.popup').click(function (e) {
    modal.openThisModal($('.js-sepa-boxmodal'), e);
  });

  $('.js-show-vk-popup a').click(function (e) {
    modal.openThisModal($('.js-vk-boxmodal'), e);
  });

  $('.js-overweight-modal-link').click(function (e) {
    modal.openThisModal($('.js-overweight-modal'), e);
  });

  const location = window.location.pathname;
  if (location.includes('preview')) {
    attachOnSubmitEvent();

    if (
      typeof cartInvalid !== 'undefined' &&
      !cartInvalid &&
      typeof locale !== 'undefined'
    ) {
      initDeliveryOptionsComponent();
    }

    if (window.isSepaExpressActive) {
      const sepaExpressService = new SepaExpressService();
      sepaExpressService.init();
    }

    if (
      typeof paymentMethod !== 'undefined' &&
      paymentMethod &&
      paymentMethod === 'AK' &&
      pspClientInfo &&
      JSON.parse(pspClientInfo)?.pspName?.includes('BRAINTREE')
    ) {
      $placeOrderBtn.click(function (event) {
        event.preventDefault();
        if (window.isBraintreeVerifiedNonceAvailable) {
          $placeOrderForm.submit();
        } else {
          disableOrderButton();
          initBraintreeVerification();
        }
      });
    }

    initPaypalButton();

    if (
      window.paymentMethod === 'AP' &&
      window.Payment.renderAdyenApplePayButton &&
      typeof window.localPaymentMethods !== 'undefined' &&
      ApplePayUtils.isEnabled()
    ) {
      renderApplePayButton(window?.localPaymentMethods);
    } else if (window.paymentMethod === RIVERTY_INVOICE) {
      loadRivertyProfileTrackingScript();
    }

    initCouponModal();
    focusAccessibleAlert();
    renderInvalidPhoneNumberWarning();
  }
  // Call publishDeliveryMetrics
  const timeoutId = setTimeout(() => {
    publishDeliveryMetrics();
  });
  return () => {
    clearTimeout(timeoutId);
  };
};

function handleButtonClick(buyBtn, btnTypeName) {
  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      sendAdobeData(
        'customClickTrack',
        'Checkout',
        `Preview ${btnTypeName} Button`,
        `${btnTypeName} Button`
      );
    });
  }
}

const tooltipConfig = {
  reducedPrice: {
    classesToRemove: ['tooltip__top', 'tooltip__top--middle'],
    classesToAdd: ['tooltip__right', 'tooltip__right--middle'],
    screenWidthValue: 544,
  },
  bestPrice: {
    classesToRemove: ['tooltip__right', 'tooltip__right--middle'],
    classesToAdd: ['tooltip__top', 'tooltip__top--middle'],
    screenWidthValue: 768,
  },
};

$(document).ready(() => {
  applyClassBasedOnResolution(
    $reducedPriceTooltip,
    tooltipConfig.reducedPrice.screenWidthValue,
    tooltipConfig.reducedPrice.classesToRemove,
    tooltipConfig.reducedPrice.classesToAdd
  );

  applyClassBasedOnResolution(
    $bestPriceTooltip,
    tooltipConfig.bestPrice.screenWidthValue,
    tooltipConfig.bestPrice.classesToRemove,
    tooltipConfig.bestPrice.classesToAdd
  );
});

$(window).resize(() => {
  applyClassBasedOnResolution(
    $reducedPriceTooltip,
    tooltipConfig.reducedPrice.screenWidthValue,
    tooltipConfig.reducedPrice.classesToRemove,
    tooltipConfig.reducedPrice.classesToAdd
  );

  applyClassBasedOnResolution(
    $bestPriceTooltip,
    tooltipConfig.bestPrice.screenWidthValue,
    tooltipConfig.bestPrice.classesToRemove,
    tooltipConfig.bestPrice.classesToAdd
  );
});

handleButtonClick(makeTheOrderBtn, 'Buy');
handleButtonClick(adyenApplePayBtn, 'Apple Pay');

function handleLinkClick(linkType) {
  sendAdobeData('customClickTrack', 'Checkout', 'Preview Legal Text', linkType);
}

const linkTypes = ['terms', 'privacy', 'withdrawalTerms'];

linkTypes.forEach((linkType) => {
  const $textLink = $legalText.find(`.${linkType}`);
  if ($textLink) {
    $textLink.on('click', function () {
      handleLinkClick(`${linkType[0].toUpperCase()}${linkType.slice(1)}`);
    });
  }
});

const marketplacePaypalButtonElement = document.getElementById(
  'marketplacePaypalButton'
);
if (marketplacePaypalButtonElement) {
  marketplacePaypalButtonElement.addEventListener('click', () => {
    SendAdobeData(
      'customClickTrack',
      'Checkout',
      'Paypal Preview Button',
      'Buy Now Marketplace'
    );
  });
}

export default PREVIEW;
export { deliveryOptionSelector };
